import React from 'react'
import Badge from '../../../../../UniformComponents/Badge'

const Applied = (props) => {
    const { show } = props

    return !show
        ? null
        : (
            <Badge
                label="Applied"
                icon="fa-solid fa-check"
                cssClass="applied"
            />
        )
}

export default Applied
